<template>
  <div class="" id="Media">
    <!-- <mt-header fixed title="权益说明">
        <router-link to="/" slot="left">
            <mt-button icon="back"></mt-button>
        </router-link>
    </mt-header> -->
    <div class="line-5"></div>
    <div class="media">
        <a href="http://k.sina.com.cn/article_6583124047_18862804f00100cvlc.html?from=auto&subch=iauto&qq-pf-to=pcqq.c2c">
            <div class="media-box">
                <img src="static/image/xinlang@2x.png" alt="">
                <span>新浪汽车媒体报道</span>
                <p>二手车电商联联车新零售在于资源整合</p>
            </div>
            <img src="static/image/next@2x.png" alt="" class="go">
        </a>
    </div>
    <div class="line-5"></div>
    <div class="media">
        <a href="http://shenzhen.auto.qq.com/a/20181023/104390.htm">
            <div class="media-box">
                <img src="static/image/tenxun.png" alt="">
                <span>腾讯媒体报道</span>
                <p>二手车电商联联车新零售在于资源整合</p>
            </div>
            <img src="static/image/next@2x.png" alt="" class="go">
        </a>
    </div>
    <div class="line-5"></div>
    <div class="media">
        <a href="http://shenzhen.auto.qq.com/a/20181206/007734.htm">
            <div class="media-box">
                <img src="static/image/tenxun.png" alt="">
                <span>腾讯媒体报道</span>
                <p>二手车社交电商开创者联联车如何驱动汽车新零售</p>
            </div>
            <img src="static/image/next@2x.png" alt="" class="go">
        </a>
    </div>
    <div class="line-5"></div>
    <div class="media">
        <a href="http://roll.sxhkstv.com/2018-11-05/126129.html">
            <div class="media-box">
                <img src="static/image/hks.png" alt="">
                <span>香港卫视媒体报道</span>
                <p>联联车发布全国首家智能社交广告系统</p>
            </div>
            <img src="static/image/next@2x.png" alt="" class="go">
        </a>
    </div>
    <div class="line-5"></div>
    <div class="media">
        <a href="https://www.pcauto.com.cn/qcbj/1335/13354947.html">
            <div class="media-box">
                <img style="width:16px;" src="static/image/taipy.png" alt="">
                <span>太平洋汽车网媒体报道</span>
                <p>二手车电商联联车新零售在于资源整合</p>
            </div>
            <img src="static/image/next@2x.png" alt="" class="go">
        </a>
    </div>
    <div class="line-5"></div>
    <div class="media">
        <a href="http://epaper.nhaidu.com/xinwen/guonews/2018/1106/95130.html">
            <div class="media-box">
                <img src="static/image/haixia.png" alt="">
                <span>海峡都市媒体报道</span>
                <p>联联车发布全国首家智能社交广告系统</p>
            </div>
            <img src="static/image/next@2x.png" alt="" class="go">
        </a>
    </div>
    <div class="line-5"></div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Header,
  Cell,
  DatetimePicker
} from 'mint-ui';
import Vue from "vue";
Vue.component(Header.name,Header);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Cell.name, Cell);
Vue.component(DatetimePicker.name, DatetimePicker);
export default {
  name: 'Media',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  loadMore() {
  this.loading = true;
  setTimeout(() => {
    let last = this.list[this.list.length - 1];
    for (let i = 1; i <= 10; i++) {
      this.list.push(last + i);
    }
    this.loading = false;
  }, 2500);
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a{
    color: #2c2c2c;
}
html{
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Media.vue